







import Vue from "vue";
import Navigator from "./components/Navigator.vue";

export default Vue.extend({
    name: "app",
    components: {
        Navigator,
    },
});
